var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPackages = function SvgPackages(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.667 4.852 8 8m0 0L2.333 4.852M8 8v6.333m6-3.627V5.294c0-.228 0-.342-.034-.444a.7.7 0 0 0-.142-.243c-.073-.079-.173-.134-.373-.245L8.518 1.62c-.189-.105-.284-.158-.384-.178a.7.7 0 0 0-.268 0c-.1.02-.195.073-.384.178l-4.933 2.74c-.2.112-.3.167-.373.246a.7.7 0 0 0-.142.243C2 4.952 2 5.066 2 5.294v5.412c0 .228 0 .342.034.444q.045.136.142.243c.073.079.173.134.373.245l4.933 2.74c.189.106.284.158.384.179q.134.027.268 0c.1-.02.195-.073.384-.178l4.933-2.741c.2-.11.3-.166.373-.245a.7.7 0 0 0 .142-.243c.034-.102.034-.216.034-.444M11 6.333 5 3"
  }))));
};
export default SvgPackages;